import { Component, OnInit } from '@angular/core';
import { NotificationsService } from '../services/notifications.service';
import { Notification, NotificationType } from '../models/notification';

@Component({
  selector: 'asv-notifications',
  template: `
    <div class="notification-container">
      <div *ngFor="let notification of notifications">
        <div class="{{ cssClass(notification) }} alert-dismissable notification-item">
          {{notification.message}}
          <a class="notification-close close" (click)="removeNotification(notification)">&times;</a>
          <div class="progress" >
            <div class="progress-bar" role="progressbar"
              [ngStyle]="{'width': calcWidth(notification) }" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
    .notification-container{
      position: absolute;
      top: 75px;
      right: 5px;
      z-index: 9999999;
    }
    .notification-container .notification-item {
      position: relative;
      width: 500px;
      padding: 0.75em 1.5em;
      border: 0 none;
    }
    .notification-container .notification-item .notification-close {
      position: absolute;
      right: 10px;
      top: 5px;
    }
    .notification-container .notification-item .progress {
      height: 5px;
      position: absolute;
      bottom: 0;
      right: 0;
      left: 0;
      width: 100%;
      border-radius: 0;
    }
    `
  ]
})
export class NotificationsComponent implements OnInit {
  public notifications: Notification[] = [];

  constructor(private notificationService: NotificationsService) { }

  ngOnInit() {
    this.notificationService.getNotification().subscribe((notification: Notification) => {
      if (!notification) {
        this.notifications = [];
        return;
      }
      this.notifications.push(notification);
    });
  }

  public removeNotification(notification: Notification) {
    this.notifications = this.notifications.filter(x => x !== notification);
  }

  public calcWidth(notification: Notification): string {
    if (!notification.noteInterval && notification.time > 0) {
      const step = 100 / notification.time;
      notification.noteInterval = setInterval(() => {
        notification.time -= 0.1;
        notification.width = notification.time * step + '%';
        if (notification.time <= 0) {
          clearInterval(notification.noteInterval);
          this.removeNotification(notification);
        }
      }, 100);
      if (notification.time <= 0) {
        clearInterval(notification.noteInterval);
        this.removeNotification(notification);
      }
    }
    return notification.width;
  }

  public cssClass(notification: Notification) {
    if (!notification) {
      return;
    }
    switch (notification.type) {
      case NotificationType.Success:
        return 'alert alert-success w-100';
      case NotificationType.Error:
        return 'alert alert-danger w-100';
      case NotificationType.Info:
        return 'alert alert-info w-100';
      case NotificationType.Warning:
        return 'alert alert-warning w-100';
    }
  }
}
